import { CLOSE_STOP_DIALOG as DIALOG } from "@libs/buy-on-behalf-client/purchase";

/** app-web's sibling of `askStop.ts`: React Native's `Alert` draws nothing
 *  on the web, so the browser's own dialog asks, its OK as Yes. */
export const askStop = async (): Promise<"stop" | "keep"> =>
  window.confirm(DIALOG.ask) ? "stop" : "keep";

/** The stop came too late: Pay was claimed first, and it goes on. */
export const sayTooLate = () => window.alert(DIALOG.tooLate);
